import React from 'react';
import PropTypes from 'prop-types';

const MissingItemAlert = ({ isMissingGender, isAddressIncomplete, isMissingPharmacy }) => {
	return (
		<div role="alert" className="alert alert-danger alert-dismissible mb0">
			<button type="button" data-dismiss="alert" aria-label="Close" className="close">
				<span aria-hidden="true">×</span>
			</button>
			<em className="fa fa-warning" />
			{' '}Patient must complete the following:
			<ul>
				{isMissingGender && (<li>Gender not set</li>)}
				{isAddressIncomplete && (<li>Address is incomplete</li>)}
				{isMissingPharmacy && (<li>Pharmacy not chosen</li>)}
			</ul>
		</div>
	);
};

MissingItemAlert.propTypes = {
	isMissingGender: PropTypes.bool,
	isAddressIncomplete: PropTypes.bool,
	isMissingPharmacy: PropTypes.bool
};

export default MissingItemAlert;
